module.exports = __webpack_public_path__ + "static/img/IMG_20241208_160053.2914ab7e.jpg";